import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { UserService } from '../../auth/user.service';

@Component({
	selector: 'app-page-not-found',
	templateUrl: './page-not-found.component.html',
	styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {

	constructor(
		private router: Router,
		private authService: AuthService,
		private userService: UserService
	) {}

	ngOnInit() {
		// Check if user has a valid session and redirect to sites-map if so
		this.checkSessionAndRedirect();
	}

	private checkSessionAndRedirect(): void {
		// Check if user is authenticated by calling the isLogged endpoint directly
		this.authService.checkSession().subscribe(
			(response: any) => {
				if (response && response.userInfo && response.userAccess) {
					console.log('User has valid session, redirecting from 404 to sites-map');
					// Update user service with the session info
					this.userService.setCurrentUser(response.userInfo, response.userAccess);
					// Update auth service user ID
					this.authService.updateUserIdAfterLogin();
					// Redirect to sites-map
					this.router.navigate(['/sites-map']);
				}
			},
			(error) => {
				// If authentication check fails, stay on 404 page
				console.log('Authentication check failed, staying on 404 page');
			}
		);
	}

}
